var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topicZero"},[_c('canvas',{ref:"todoChess",staticStyle:{"width":"100%"},attrs:{"width":"500","height":"500"}})])}
var staticRenderFns = []

export { render, staticRenderFns }